export default __webpack_public_path__ + "static/media/Amazon Web Services.4191a135.png";